<script lang="ts">
  import { onMount } from "svelte";
  import { AppStore } from "./utils/store";

  const LS = "admin_micral_token";

  let value: string;
  onMount(() => {
    const ls = localStorage.getItem(LS);

    if (ls) {
      AppStore.setToken(ls);
      value = ls
    }
  });

  function handleSubmit() {
    AppStore.setToken(value);
    localStorage.setItem(LS, value);
  }
</script>

<form class="container" on:submit|preventDefault={handleSubmit}>
  <input class="input" bind:value placeholder="token" />
  <button class="button">Valider</button>
</form>

<style>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 8px;
  }

  .input {
    outline: none;
    height: 100%;
    border: none;
    background: #424242;
    color: #9c9898;
    padding: 10px;
  }
</style>
